"use strict";

exports.__esModule = true;
exports.styled = void 0;
var _styled = _interopRequireDefault(require("./styled"));
exports.styled = _styled.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}